import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Action, BaseRepublishDto, LogDto, State } from '@coin/importer/dto/util';
import { Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { PopupComponent } from '../../components/popup/popup.component';
import { LogsService } from '../../services/logs/logs.service';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'importer-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
  standalone: false
})
export class SummaryComponent implements OnInit, OnDestroy {
  private matDialog = inject(MatDialog);
  private route = inject(ActivatedRoute);
  private logsService = inject(LogsService);
  private router = inject(Router);
  private toast = inject(ToastService);

  public data: LogDto;
  public isLoading: boolean;
  public actionEnum = Action;
  private destroy$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    this.isLoading = true;
    this.route.params
      .pipe(
        tap(() => {
          this.isLoading = true;
        }),
        switchMap(params => this.logsService.getSingleImportLog(params.id)),
        takeUntil(this.destroy$)
      )
      .subscribe(obj => {
        this.data = obj;
        this.isLoading = false;
      });
  }

  formatErrorMessage(input: string | undefined): string {
    if (!input || typeof input !== 'string') return '';
    return input.split('jobRunId')[0].trim();
  }

  openPopup(action: Action): void {
    const popup = this.matDialog.open(PopupComponent, {
      disableClose: true,
      data: {
        log: this.data,
        action
      }
    });
    popup.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(this.popupResponse.bind(this));
  }

  private popupResponse(response?: LogDto) {
    if (response) {
      if (response.decision) {
        this.data.decision = response.decision;
        this.data.state =
          response.decision.action === Action.Reject
            ? State.Rejecting
            : response.decision.publish
              ? State.Publishing
              : State.Patching;
      }
      if (response.coinProcessingState) {
        this.data.coinProcessingState = response.coinProcessingState;
      }
    }
  }

  republishChanges(): void {
    this.logsService
      .republishChanges(this.data.id, this.data.fileType.prefix)
      .pipe(takeUntil(this.destroy$))
      .subscribe((republishDto: BaseRepublishDto) => {
        this.toast.success('The changes will be republished.');
        this.router.navigate(['republish_summary', republishDto.id]);
      });
  }

  goBack() {
    this.router.navigate(['']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
